import fetchCoverage, { Data } from "@/api/fetchCoverage";
import MapHeat from "@/components/Map/Heat";
import Meta from "@/components/Meta";
import NavigationPresetDefault from "@/components/Navigation/Preset/Default";
import Page from "@/components/Page";
import { GetServerSideProps } from "next";
import { FunctionComponent, useEffect, useState } from "react";

type Props = {
  coverage: Data;
};

const MapCoverage: FunctionComponent<Props> = ({ coverage }) => {
  const [zoom, setZoom] = useState(8);
  useEffect(() => {
    if (window.innerWidth < 800) {
      setZoom(6);
    }
  }, []);
  return (
    <Page navigation={NavigationPresetDefault}>
      <Meta type={"information"} title={"Mapa pokrytí"} />

      <MapHeat
        coverage={coverage.coverage}
        lng={19.699}
        lat={48.669}
        zoom={zoom}
      />
    </Page>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const data = await fetchCoverage({});

  return {
    props: {
      coverage: data.data,
    },
  };
};

export default MapCoverage;
